angular.module('ui-ng-sibling', []);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-sibling/src/core.js